import Work1 from "../../assets/work7.jpg";
import Work2 from "../../assets/work6.jpg";
import Work3 from "../../assets/work10.jpg";
import Work4 from "../../assets/work9.jpg";
import Work5 from "../../assets/work8.jpg";
import Work6 from "../../assets/pokedex.jpg";
import Work11 from "../../assets/work11.jpg";
import Work12 from "../../assets/work12.jpg";
import Work13 from "../../assets/work13.png";

export const projectsData = [
  {
    id: 1,
    image: Work1,
    title: "E-commerce Website",
    category: "web",
    link: "https://zipp-shipp.netlify.app/",
  },
  {
    id: 2,
    image: Work2,
    title: "Spotify App",
    category: "app",
    link: "https://exquisite-bavarois-72a25b.netlify.app/",
  },
  {
    id: 3,
    image: Work3,
    title: "Youtube Design",
    category: "design",
    link: "https://yuotube.netlify.app/",
  },
  {
    id: 4,
    image: Work4,
    title: "Dice Roll",
    category: "App",
    link: "https://resilient-tulumba-4e5507.netlify.app/",
  },
  {
    id: 5,
    image: Work5,
    title: "Portfolio",
    category: "web",
    link: "/",
  },
  {
    id: 6,
    image: Work6,
    title: "Pokedex",
    category: "web",
    link: "https://pokedexx-x.netlify.app/",
  },
  {
    id: 7,
    image: Work11,
    title: "BeautyBurst",
    category: "web",
    link: "https://beautyburst.pages.dev/",
  },
  {
    id: 8,
    image: Work12,
    title: "Multimart",
    category: "web",
    link: "https://ee-mart.netlify.app/home",
  },
  {
    id: 9,
    image: Work13,
    title: "Facebook",
    category: "web",
    link: "https://fecbuk.netlify.app/",
  },
];

export const projectsNav = [
  {
    name: "all",
  },
  {
    name: "web",
  },
  {
    name: "app",
  },
  {
    name: "design",
  },
];
